import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';

import prizesHero from '../components/prizes/images/prizes-hero.png';
import '../components/prizes/style.scss';

export const Prizes = ({ user, notification, actions }) => {
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Prizes" />
            <PrizesInner />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Prizes);

export const PrizesInner = () => {
    return (
        <div className="content-container prizes">
            <div className="row">
                <div className="col-md-10 col-md-offset-1">
                <div className="media mx-auto">
                    </div>
                        <h1>
                            2ND CHANCE PROMOTION  DRAWING<br />
                            <span className='heading-large-line'>PRIZES</span>
                        </h1>
                    <img
                        src={prizesHero}
                        alt="Enter For a chance to win up to $200,000 in Cash Prizes"
                        className="img-responsive center-block mt-5 mb-3"
                    />

                    <div className="content-copy-container">
                        <h2>TWELVE WEEKS OF HOLIDAY WINNINGS 2ND CHANCE DRAWINGS</h2>
                        <p>The Illinois Lottery shall conduct 12 weekly drawings to award 50 $500 cash prizes per drawing, for a total of 600 cash prizes.  In addition to the weekly drawings, the Illinois Lottery shall conduct one Final Drawing for one (1) winner of $200,000 cash!</p>
                        <p>The prizewinners shall be notified by the Illinois Lottery or its designee.</p>
                        <p>These prizes are subject to applicable taxes and withholdings and the Illinois Lottery’s debt setoff procedures.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
